import { useState, useEffect } from "react";
import { useQuery } from "@apollo/client";
import { GET_PERFORMACE_PAGINATION } from "../Schema/Performance";

const useGetPerformancePagination = ({ classId, subjectId }) => {
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [keyword, setKeyword] = useState("");
  const [loading, setLoading] = useState(true);
  const [tableData, setTableData] = useState([]);
  const [paginationData, setPaginationData] = useState();

  // console.log("classId: ss:", classId, subjectId);

  const { refetch } = useQuery(GET_PERFORMACE_PAGINATION, {
    variables: {
      page: page,
      limit: limit,
      keyword: keyword,
      pagination: true,
      classId: classId ?? "",
      subjectId: subjectId ?? "",
    },
    onCompleted: ({ getPerformancePagination }) => {
      // console.log("getPerformancePagination::::", getPerformancePagination);
      setTableData(getPerformancePagination?.data);
      setPaginationData(getPerformancePagination?.paginator);
      setLoading(false);
    },
    onError: (err) => {
      console.log("Error::", err?.message);
    },
  });

  const handleSearch = (e) => {
    setPage(1);
    setKeyword(e.target.value);
  };

  useEffect(() => {
    refetch();
  }, [page, keyword, classId, subjectId]);

  const handleLimit = (e) => {
    setLimit(e.target.value);
    setPage(1);
  };

  return {
    page,
    setPage,
    refetch,
    loading,
    setLoading,
    limit,
    handleLimit,
    handleSearch,
    tableData,
    paginationData,
  };
};

export default useGetPerformancePagination;
